// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--NG_V2","tab":"_9e1425b4d3--tab--ZOXFK","_active":"_9e1425b4d3--_active--ONJ7i","icon-wrapper":"_9e1425b4d3--icon-wrapper--jwHUZ"};